import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";
import { isAdminRole } from "../../auth/utils/roles";

export const registerAccount = async ({
  email,
  userName,
  mobileNumber,
  firstName,
  middleName,
  lastName,
  dateOfBirth,
  role,
  password,
  contactId,
}) => {
  const ROUTE = urlConfig.backend.routes.authentication.register;
  const url = `${BACKEND_URL}${ROUTE}`;

  const reqData = {
    email,
    username: userName,
    phone_number: mobileNumber,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    date_of_birth: dateOfBirth,
    role,
    password,
  };

  if (!isAdminRole(role) && contactId != null) {
    reqData.contact_id = contactId;
  }

  return await axios
    .post(url, reqData)
    .then((res) => {
      if (res.status === 200) {
        return { error_code: 1 };
      }
      return {
        error_code: 2,
        error_message: "Please check all required fields",
      };
    })
    .catch((error) => {
      const status = error.response?.status;
      const data = error.response?.data;

      if (status === 422) {
        const message =
          typeof data?.message === "string"
            ? data.message
            : "Registration failed. Please check your entries.";
        const contactErrors = data?.errors?.contact_id;
        const hasContactFieldErrors =
          Array.isArray(contactErrors) && contactErrors.length > 0;

        return {
          error_code: 3,
          error_message: hasContactFieldErrors ? contactErrors[0] : message,
          ...(hasContactFieldErrors || reqData.contact_id != null
            ? { field: "contact_id" }
            : {}),
        };
      }

      if (status === 400 && data?.errors) {
        const firstField = Object.keys(data.errors)[0];
        const firstMessage = data.errors[firstField]?.[0];
        return {
          error_code: 3,
          error_message:
            typeof firstMessage === "string"
              ? firstMessage
              : typeof data?.message === "string"
                ? data.message
                : "Please check all required fields",
          ...(firstField ? { field: firstField } : {}),
        };
      }

      return {
        error_code: 2,
        error_message:
          typeof data?.message === "string"
            ? data.message
            : error.message || "Registration failed",
      };
    });
};
